
import { CPTextInput } from '@capital-platforms/cpui';
import { Component, InjectReactive, Prop, Vue } from 'vue-property-decorator';
import CPOpenAccountFormSubsection from '../open-account/form/CPOpenAccountFormSubsection.vue';
import { EmploymentDetails } from '@/store/dueDiligence/types';

@Component({
    components: {
        CPTextInput,
        CPOpenAccountFormSubsection
    }
})
export default class CPDueDiligenceAccountHolderEmploymentDetails extends Vue {
    @Prop({ required: true}) employmentDetails!: EmploymentDetails;
    @InjectReactive() readonly viewOnly!: boolean
}
